// SPDX-License-Identifier: AGPL-3.0-or-later

import type {Guild} from '@app/features/guild/models/Guild';
import {DataMenuRenderer} from '@app/features/ui/action_menu/DataMenuRenderer';
import {useGuildMenuData} from '@app/features/ui/action_menu/items/GuildMenuData';
import {MuteCommunityMenuItem} from '@app/features/ui/action_menu/items/GuildMenuItems';
import {MenuGroup} from '@app/features/ui/action_menu/MenuGroup';
import {useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';
import type React from 'react';
import {useMemo} from 'react';

interface GuildContextMenuProps {
	guild: Guild;
	onClose: () => void;
}
export const GuildContextMenu: React.FC<GuildContextMenuProps> = observer(({guild, onClose}) => {
	const {t} = useLingui();
	const {groups} = useGuildMenuData(guild, {onClose});
	const excludeLabels = useMemo(() => [t`Mute Community`, t`Unmute Community`], [t]);
	return (
		<>
			<DataMenuRenderer groups={groups} excludeLabels={excludeLabels} />
			<MenuGroup>
				<MuteCommunityMenuItem guild={guild} onClose={onClose} />
			</MenuGroup>
		</>
	);
});
